<template>
    <div>
        <div v-if="!notFound">
            <div class="showcase-hero" v-bind:style="{ 'background-image': 'linear-gradient(rgba(0, 0, 0, 0.25) 0%, rgba(0, 0, 0, 0.5) 50%, rgba(0, 0, 0, 0.25) 100%), url(https://i.vimeocdn.com/video/' + showcase.first_picture  + '-' + showcase.first_picture_key +'-d_1200x500)' }">
                <div class="signin-button">
                    <div class="btn-toolbar" >
                        <SelectCurrencies @currency-changed-callback="currencyChangedCallback"></SelectCurrencies>
                        <SelectLanguages></SelectLanguages>
                        <a class="btn btn-default" @click="visibleLoginModal=true" v-if="!userConsumer">
                            <i class="las la-door-open"></i>{{$t('common.sign_in')}}
                        </a>
                        <a class="btn btn-danger" @click="logoutClick" v-else>
                            <i class="las la-sign-out-alt"></i>{{$t('common.logout')}}
                        </a>
                    </div>
                </div>
                <div class="hero-inner">
                    <div class="container">
                        <div class="hero-logo"><img src="https://respira.yoga/wp-content/themes/respirayoga/img/respirayoga-logo.png"></div>
                        <h1>{{showcase.title}}</h1>
                        <h2>{{showcase.description}}</h2>
                        <router-link v-if="showcase.limited" class="btn btn-default btn-lg" :to="{name:'showcase_checkout', params: {showcase_fingerprint: showcase.fingerprint}}">
                            <i class="las la-unlock"></i>{{$t('views.showcase_consumer.purchase_now', {price: priceString})}}
                        </router-link>
                    </div>
                </div>
            </div>
            <div class="container">
                <div v-if="hasVideoWithoutCategory">
                    <div class="row margin-bottom-20">
                        <div v-for="video_showcase in showcase.videos" v-bind:key="video_showcase.video.id" >
                            <div v-if="video_showcase.category === null">
                                <div class="col-xs-12 col-sm-6 col-md-4 col-lg-3 margin-bottom-20">
                                    <div  class="showcase-item active" @click.prevent.stop="showPlayShowcaseModal(video_showcase.video)">
                                        <div class="item-container">
                                            <img class="img-responsive" :src="'https://i.vimeocdn.com/video/' + video_showcase.video.picture_id + '-' + video_showcase.video.picture_key +'-d_800x500'">
                                            <i v-if="showcase.limited" class="las la-lock"></i>
                                            <div class="item-inner">
                                                <div class="row">
                                                    <div class="col-xs-8 bold">{{video_showcase.video.title}}</div>
                                                    <div class="col-xs-4 text-right"><small>{{getDurationTime(video_showcase.video.duration)}}</small></div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-for="category in showcase.categories" v-bind:key="category.id">
                    <h2 class="showcase-h2">{{category.name}}</h2>
                    <div class="row margin-bottom-20">
                        <div v-for="video_showcase in showcase.videos" v-bind:key="video_showcase.video.id" >
                            <div v-if="video_showcase.category === category.id">
                                <div class="col-xs-12 col-sm-6 col-md-4 col-lg-3 margin-bottom-20">
                                    <div  class="showcase-item active" @click.prevent.stop="showPlayShowcaseModal(video_showcase.video)">
                                        <div class="item-container">
                                            <img class="img-responsive" :src="'https://i.vimeocdn.com/video/' + video_showcase.video.picture_id + '-' + video_showcase.video.picture_key +'-d_800x500'">
                                            <i v-if="showcase.limited" class="las la-lock"></i>
                                            <div class="item-inner">
                                                <div class="row">
                                                    <div class="col-xs-8 bold">{{video_showcase.video.title}}</div>
                                                    <div class="col-xs-4 text-right"><small>{{getDurationTime(video_showcase.video.duration)}}</small></div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div style="padding:50px;text-align:center;">
                <span class="text-muted">Powered by Respira Yoga</span>
            </div>
            <PlayShowcaseModal
                    v-show="visiblePlayShowcaseModal"
                    :visible="visiblePlayShowcaseModal"
                    :video="selectedVideo"
                    :locked="showcase.limited"
                    :showcase="showcase"
                    @go-to-checkout="goToCheckout"
                    @sign-in="signInFromPlayModal"
                    @close-play-showcase-modal="closePlayShowcase"></PlayShowcaseModal>
            <SpinnerLoader v-show="loading"></SpinnerLoader>
            <div class="showcase-password" v-show="passwordRequired">
                <div class="showcase-password-inner">
                    <h1>{{$t('views.showcase_consumer.password_required_title')}}</h1>
                    <p class="margin-bottom-20">{{$t('views.showcase_consumer.password_required_message')}}</p>
                    <div
                            v-show="passwordWrong"
                            class="alert alert-danger"
                            role="alert"
                    >
                        {{$t('views.showcase_consumer.password_required_error')}}
                    </div>
                    <div class="row">
                        <div class="col-xs-8">
                            <input class="form-control input-lg" type="text" value="" :placeholder="$t('views.showcase_consumer.password_required_placeholder')" v-model="password">
                        </div>
                        <button class="btn btn-primary btn-lg col-xs-4" @click.prevent.stop="getPublicShowcaseDetailWithPassword(password)"><i class="las la-unlock"></i>{{$t('common.submit')}}</button>
                    </div>
                </div>
            </div>
            <SpinnerLoader v-show="loading"></SpinnerLoader>
            <LoginModal
                    v-show="visibleLoginModal"
                    :visible="visibleLoginModal"
                    @success-login="handleSuccessLogin"
                    @close-login-modal="visibleLoginModal=false"
            />
        </div>
        <div v-else>
            <p
                    class="alert alert-danger margin-20"
                    role="alert"
            >
                {{$t('views.showcase_consumer.not_found')}}
            </p>

        </div>
    </div>
</template>

<script>
    import SpinnerLoader from "../components/common/SpinnerLoader";
    import PlayShowcaseModal from "../components/modal/PlayShowcaseModal";
    import {LocaleHelper} from "../common/localeHelper";
    import {
        getPublicShowcaseDetail,
        getPublicShowcaseDetailWithPassword,
        getPublicShowcaseDetailWithToken
    } from "../api";
    import {Utils} from "../common/utils";
    import {SHOWCASE_PRIVACY} from "../common/constants";
    import LoginModal from "../components/modal/LoginConsumerModal";
    import {StorageHelper} from "../common/storageHelper";
    import SelectLanguages from "../components/common/SelectLanguages";
    import SelectCurrencies from "../components/common/SelectCurrencies";
    import defaultMixin from "../common/defaultMixin";

    export default {
        title: "Showcase",
        name: "Showcase",
        components: {SelectLanguages, SelectCurrencies, SpinnerLoader, PlayShowcaseModal, LoginModal },
        mixins: [defaultMixin],
        async mounted() {
            this.userConsumer = StorageHelper.getUserConsumer();
            await this.getPublicShowcaseDetail();
            if (this.$route.params.lang) {
                this.selectLang(this.$route.params.lang)
            }
        },
        data: () => {
            return {
                userConsumer: null,
                visiblePlayShowcaseModal: false,
                visibleLoginModal: false,
                showcase: {},
                loading: false,
                passwordRequired: false,
                notFound: false,
                password: "",
                passwordWrong: false,
                selectedVideo: {},
                showcasePrivacyEnum: SHOWCASE_PRIVACY,
                defaultCurrency: Utils.getDefaultCurrency(),
                priceString: '0.00'
            }
        },
        computed: {
            hasVideoWithoutCategory() {
              if (this.showcase.videos) {
                  for (let i = 0; i < this.showcase.videos.length; i++) {
                      if (this.showcase.videos[i].category === null) {
                          return true
                      }
                  }
              }
              return false
            },

        },
        methods: {
            closePlayShowcase() {
                this.visiblePlayShowcaseModal=false;
                this.selectedVideo = {};
            },
            goToCheckout() {
                this.visiblePlayShowcaseModal = false;
                this.$nextTick(() => {
                    this.$router.push({name:'showcase_checkout', params: {showcase_fingerprint: this.showcase.fingerprint}});
                });
            },
            signInFromPlayModal() {
                this.visiblePlayShowcaseModal = false;
                this.$nextTick(() => {
                    this.visibleLoginModal = true
                });
            },
            logoutClick() {
                Utils.logoutConsumer();
                this.userConsumer = null;
                this.getPublicShowcaseDetail();
            },
            async handleSuccessLogin() {
                this.visibleLoginModal = false;
                this.userConsumer = StorageHelper.getUserConsumer();
                this.getPublicShowcaseDetail();

            },
            getCurrencySymbolFromString(currency) {
                return Utils.getCurrencySymbolFromString(currency)
            },
            async getPublicShowcaseDetail() {
                try {
                    this.loading = true;
                    if (this.userConsumer) {
                        this.showcase = await getPublicShowcaseDetailWithToken(this.$route.params.showcase_fingerprint);
                    } else {
                        this.showcase = await getPublicShowcaseDetail(this.$route.params.showcase_fingerprint);
                    }
                    this.priceString = await Utils.getPriceString(this.showcase.price, this.showcase.price_currency);
                    this.loading = false;
                } catch (e) {
                    if (e.response.data.code === "password_required_showcase") {
                        this.passwordRequired = true;
                    } else if (e.response.status === 404){
                        this.notFound = true;
                    }
                    this.loading = false;
                    console.log(e)
                }
            },

            async getPublicShowcaseDetailWithPassword() {
                try {
                    this.loading = true;
                    this.showcase = await getPublicShowcaseDetailWithPassword(this.$route.params.showcase_fingerprint, this.password);
                    this.loading = false;
                    this.passwordRequired = false;
                    this.passwordWrong = false;
                    this.videos = []
                } catch (e) {
                    if (e.response.data.code === "password_required_showcase") {
                        this.passwordRequired = true;
                        this.passwordWrong = true;
                    }
                    this.loading = false;
                }
            },
            getDurationTime(seconds) {
                return Utils.getDurationTime(seconds)
            },
            selectLang(lang) {
                LocaleHelper.setLanguage(lang);
            },
            showPlayShowcaseModal(video){
                this.selectedVideo = video;
                this.visiblePlayShowcaseModal = true
            },
            saveVideosWithSeparator(videos) {
                let videosWithSeparator = [];
                for (let i = 0; i < videos.length; i++) {
                    if (i === 0) {
                        if (videos[i].category != null) {
                            videosWithSeparator.push({ separator: true, separator_name: this.getNameCategory(videos[i].category), separator_id: videos[i].category});
                        }
                    } else if (videos[i].category !== videos[i-1].category) {
                        if (videos[i].category != null) {
                            videosWithSeparator.push({ separator: true, separator_name: this.getNameCategory(videos[i].category), separator_id: videos[i].category});
                        }
                    }
                    videosWithSeparator.push(videos[i])

                }

                this.videos = videosWithSeparator;
            },
            getNameCategory(category_id) {
                for (let i = 0; i < this.showcase.categories.length; i++ ) {
                    if (this.showcase.categories[i].id === category_id) {
                        return this.showcase.categories[i].name
                    }
                }
                return ""
            },

            async currencyChangedCallback(currency) {
                this.defaultCurrency = currency;
                this.priceString = await Utils.getPriceString(this.showcase.price, this.showcase.price_currency);
            }
        },
        watch: {
            "showcase.videos"(newVal) {
                this.saveVideosWithSeparator(newVal, this.showcase.categories_unselected)
            }
        }

    };
</script>
